module.exports = __webpack_public_path__ + "544cff6a5f13b67db5d2315061ec09ed.png";